/* @flow */

export const MARK_CHECK_IN_ANIMATION_AS_RUNNING =
  'MARK_CHECK_IN_ANIMATION_AS_RUNNING';
export const MARK_CHECK_IN_ANIMATION_AS_DONE =
  'MARK_CHECK_IN_ANIMATION_AS_DONE';

export const MARK_CHECKIN_FETCHING = 'MARK_CHECKIN_FETCHING';
export const MARK_CHECKIN_SUCCESS = 'MARK_CHECKIN_SUCCESS';
